import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { formatDate } from "../../utils/formatters";
import { FaTrash, FaReply } from "react-icons/fa";

const CommentsList = ({ comments = [], onDelete, onReply }) => {
  const { currentUser } = useAuth();
  const [confirmDelete, setConfirmDelete] = useState(null);
  console.log("Comments structure:", comments);
  // Trier les commentaires du plus récent au plus ancien
  const sortedComments = [...comments].sort(
    (a, b) =>
      new Date(b.createdAt || b.timestamp) -
      new Date(a.createdAt || a.timestamp)
  );

  // Format de l'affichage des mentions
  const formatComment = (text) => {
    // Remplacer les mentions par des liens stylisés
    return text.replace(
      /@(\w+)/g,
      '<span class="text-primary-600 font-semibold">@$1</span>'
    );
  };

  if (!comments || comments.length === 0) {
    return (
      <p className="text-gray-500 italic">Aucun commentaire pour l'instant.</p>
    );
  }

  return (
    <div className="space-y-4 h-64 overflow-y-auto pr-2">
      {sortedComments.map((comment) => (
        <div
          key={comment._id}
          className="bg-gray-50 p-3 rounded-lg border border-gray-200"
        >
          <div className="flex justify-between text-sm mb-1">
            <span className="font-medium text-primary-700">
              {comment.author
                ? comment.author.username ||
                  comment.author.email ||
                  "Utilisateur"
                : "Utilisateur"}
            </span>
            <span className="text-gray-500">
              {formatDate(comment.createdAt || comment.timestamp, true)}
            </span>
          </div>

          <div className="text-gray-800 mb-2">
            {/* Afficher le nom de l'utilisateur suivi du contenu du commentaire */}
            <strong className="text-primary-600">
              {comment.authorName || "Utilisateur"}
            </strong>
            <span> : </span>
            <span
              dangerouslySetInnerHTML={{ __html: formatComment(comment.text) }}
            />
          </div>

          <div className="flex justify-end space-x-2 text-xs">
            {onReply && (
              <button
                onClick={() => onReply(comment.author?.username)}
                className="text-blue-600 hover:text-blue-800 flex items-center"
              >
                <FaReply className="mr-1" /> Répondre
              </button>
            )}

            {onDelete &&
              currentUser &&
              (currentUser._id === (comment.author?._id || comment.author) ||
                currentUser.role === "admin") && (
                <button
                  onClick={() => setConfirmDelete(comment._id)}
                  className="text-red-600 hover:text-red-800 flex items-center"
                >
                  <FaTrash className="mr-1" /> Supprimer
                </button>
              )}
          </div>

          {/* Confirmation de suppression */}
          {confirmDelete === comment._id && (
            <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
              <p className="text-sm text-red-700 mb-2">
                Êtes-vous sûr de vouloir supprimer ce commentaire ?
              </p>
              <div className="flex justify-end space-x-2">
                <button
                  onClick={() => setConfirmDelete(null)}
                  className="px-2 py-1 text-xs bg-gray-200 text-gray-700 rounded"
                >
                  Annuler
                </button>
                <button
                  onClick={() => {
                    onDelete(comment._id);
                    setConfirmDelete(null);
                  }}
                  className="px-2 py-1 text-xs bg-red-600 text-white rounded"
                >
                  Confirmer
                </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CommentsList;
